import './App.css';
import LandingPage from './Components/LandingPage';
import About from './Components/About';
import Services from './Components/Services';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Contact from './Components/Contact';
import Robotic from './Components/Robotic';
import Revenue from './Components/Revenue';
import Speciality from './Components/Speciality';
import Emr from "./Components/Emr";
import Medical from "./Components/Medical";
import Why from "./Components/Why";
import Special from "./Components/Special";
function App() {
  return (
   <>
    <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/LandingPage" replace />} />
            <Route path="/LandingPage" element={<LandingPage />} />
            <Route path="/About" element={<About />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Robotic" element={<Robotic/>} />
            <Route path="/Revenue" element={<Revenue/>} />
            <Route path="/Speciality" element={<Speciality/>} />
            <Route path="/Emr" element={<Emr/>} />
            <Route path="Medical" element={<Medical/>} />
            <Route path="Why" element={<Why/>} />
            <Route path="Special" element={<Special/>} />
          </Routes>
        </Router>
   </>
  ); 
}

export default App;
